const FIVE_MINUTES_MS = 5 * 60 * 1000

/**
 * Shared by the `documents/$documentKey` loader's prefetch and `useSubscriptionUnderwriting`. Both need `gcTime`: the
 * global client runs `gcTime: 0`, which evicts an observer-less prefetch before the page mounts. No `staleTime`: a
 * study moves while it runs, so a remount reads it again.
 *
 * See `routing-frontend.md`, "A section whose existence depends on its data", for how the value is sized.
 */
export const SUBSCRIPTION_UNDERWRITING_QUERY_OPTIONS = { gcTime: FIVE_MINUTES_MS }
